import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConfirmWithMessageContent } from '../../../components/core';
import * as Handlers from '../../Utils/handlers';
import { resetDismissNotificationData, updateDismissNotificationData, updateEmployeeDashboardData, updateLoading } from '../../../actions';
import { withTranslation } from 'react-i18next';

class DismissConfirmation extends Component {

    handleConfirmDismiss = () => {
        const { dismissNotificationData, resetDismissNotificationData } = this.props;
        Handlers.handleDismissButton.bind(this)(dismissNotificationData.offerId, dismissNotificationData.proposalId, dismissNotificationData.isVTO);
        resetDismissNotificationData();
    };

    handleCancelDismiss = () => {
        const { resetDismissNotificationData } = this.props;
        resetDismissNotificationData();
    };

    render() {
        const { t } = this.props;

        return (
            <div className="comment-to-manager-container">
                <ConfirmWithMessageContent
                    title={t('dialog.notification.titleDismiss')}
                    header={t('dialog.notification.headerDismiss')}
                    showTextField={false}
                    onCancel={this.handleCancelDismiss} W
                    onConfirm={this.handleConfirmDismiss}
                >
                </ConfirmWithMessageContent>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    formData: state.mobileOfferShiftForm,
    options: state.httpOptions,
    storeData: state.data,
    dismissNotificationData: state.dismissNotificationData,
});

const mapDispatchToProps = {
    updateLoading,
    updateEmployeeDashboardData,
    updateDismissNotificationData,
    resetDismissNotificationData
};

export default connect(mapStateToProps, mapDispatchToProps)((withTranslation('employmentBillboard'))(DismissConfirmation));